export default __webpack_public_path__ + "static/media/feed.bc162787.svg";